import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReAuth } from '@/store/features/baseRtkQuery';
import type { EonPerformanceResponse } from '@/app/ops/dashboards/eon/types';

export type EonPerformanceParams = {
    from?: string | null;
    to?: string | null;
    /** Aggregate the preceding window of equal length too, for period-over-period deltas. */
    comparePrevious?: boolean;
    granularity?: 'day' | 'hour' | 'week' | 'month';
};

function buildSearch(params?: EonPerformanceParams) {
    const search = new URLSearchParams();
    if (params?.from) search.set('from', params.from);
    if (params?.to) search.set('to', params.to);
    if (params?.comparePrevious === false) search.set('comparePrevious', 'false');
    if (params?.granularity) search.set('granularity', params.granularity);
    return search.toString();
}

export const opsEonApiSlice = createApi({
    reducerPath: 'opsEonApi',
    baseQuery: baseQueryWithReAuth,
    tagTypes: ['EonPerformance'],
    endpoints: (builder) => ({
        getEonPerformanceDashboard: builder.query<EonPerformanceResponse, EonPerformanceParams | void>({
            query: (params) => ({
                url: `api/ops/eon/performance-adoption?${buildSearch(params ?? undefined)}`,
                method: 'GET',
            }),
            providesTags: ['EonPerformance'],
        }),
    }),
});

export const opsEonApiActions = {
    useGetEonPerformanceDashboardQuery: opsEonApiSlice.useGetEonPerformanceDashboardQuery,
};
